module.exports = __webpack_public_path__ + "c2b7308617178ccfbd4c06b16e6b593d.png";